var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
		{'pb-12 lg:pb-0': _vm.showCategoriesTab},
		'min-h-130'
	],attrs:{"id":"business-index"}},[(_vm.showCategoriesTab)?_c('BusinessCategoryTab'):_vm._e(),_vm._v(" "),(_vm.showMenuTab)?_c('BusinessMenuTab'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }